var g_data = {};

//ユーザー仕様対象か
export function customTarget(corpkey, key) {
    if (corpkey === key) return true;
    if (corpkey.startsWith(key)) return true;
    return false;
}


//グローバル領域に格納
export function setglobaldata(key, data) {
    g_data[key] = JSON.stringify(data);
}
//グローバル領域から読込
export function getglobaldata (key) {
    if (isEmpty(g_data[key])) return g_data[key];
    return JSON.parse(g_data[key]);
}
//グローバル領域から指定キーを削除
export function removeglovaldata(key, like) {
    if (!like) {    //完全一致
        if (key in g_data) delete g_data.key;
        return;
    }
    for (let k in g_data) {
        if (k.indexOf(key) !==-1) {
            delete g_data[k];
        } 
    }
}
//cookieに書き込み(期限30日）
export function setcookie(key, data) {
    var exp = 60 * 60 * 24 * 30;    //有効期限30日
    document.cookie = 'availplm_' + key + '=' + encodeURIComponent(data) + ';max-age=' + exp;
}
//cookieから指定キーデータを読込
export function getcookie(key) {
    var result = "";

    var cookieName = 'availplm_' + key + '=';
    var allcookies = document.cookie;

    var position = allcookies.indexOf(cookieName);
    if (position !== -1) {
        var startIndex = position + cookieName.length;

        var endIndex = allcookies.indexOf(';', startIndex);
        if (endIndex === -1) {
            endIndex = allcookies.length;
        }
        result = decodeURIComponent(
            allcookies.substring(startIndex, endIndex));
    }
    return result;
}
//ローカルストレージのキーを取得
export function storageKey(corpkey, account, key) {
    return "availplm." + corpkey + '_' + account + '_' + key;
}
//ローカルストレージにキーに対する値が存在するかチェック
export function storageExistsKey(key) {
    return (localStorage.getItem(key) !== null);
}
//ローカルストレージに永久データを保存
export function Savestorage(corpkey, account, id, data) {
    let key = storageKey(corpkey, account, id);
    localStorage.setItem(key, JSON.stringify(data));
}
//ローカルストレージから永久データ読み出し
export function Getstorage(corpkey, account, id) {
    let key;
    if (account === undefined && id === undefined) {
        key = corpkey;
    } else {
        key = storageKey(corpkey, account, id);
    }
    try {
        return JSON.parse(localStorage.getItem(key));
    } catch {
        return null;
    }
}
//ローカルストレージから永久データを削除
export function Removestorage(corpkey, account, id) {
    let key = storageKey(corpkey, account, id);
    localStorage.removeItem(key);
}
//ローカルストレージから指定IDを含むキーの永久データをすべて削除
export function DeleteKeystorage(corpkey, account, id) {
    let target = storageKey(corpkey, account, id);
    for (var key in localStorage) {
        if (key.indexOf(target) !== -1) {
            localStorage.removeItem(key);
        }
    }
}
//セッションストレージにデータを保存
export function Storestorage(key, data) {
    sessionStorage.setItem(key, JSON.stringify(data));
}
//セッションストレージからデータ読み出し
export function Loadstorage(key) {
    return JSON.parse(sessionStorage.getItem(key));
}
//データディープコピー
export function DeepCopy(data) {
    const clone = JSON.stringify(data);
    return JSON.parse(clone);
}

export function CellType() {
    return {
        TEXT: '0', NUM: '1', DATE: '2', TEXTAREA: '3', SELECT: '4',
        MASTERREF: '5', MASTER: '6', MASTERCODE: '7', MASTERASST: '8',
        TAG: '10', STICKY: '11', COLOR: '12', CHECK: '13', APPROVAL: '14', SPIN:'15', RADIO:'16',YEAR:'20',IMAGE:'30',
        SEARCHNUM: '51', SEARCHDATE: '52', SEARCHYM: '53', SEARCHYMRANGE: '54', SEARCHYMSTR: '55', SEARCHYMRANGESTR: '56', SEARCHTEXTRANGE:'57'
    };
}

//タグ文字列の成型（重複除去、半角スペース区切り）
export function tagformat(tagvalue) {
    if (isEmpty(tagvalue)) return tagvalue;
    const tags = replaceall(replaceall(tagvalue, "　", " "), "\t", "").split(' ');
    let newtag = Array.from(new Set(tags));   //重複除去
    newtag = newtag.filter(function (tag) {
        return tag !== '';
    });
    return newtag.join(' ');
}

//targetからtagを除去
export function removetag(target, removetags) {
    if (isEmpty(target)) return target;
    let tags = replaceall(replaceall(removetags, "　", " "), "\t", "").split(' ');
    let newtag = target.split(' ').filter(i => tags.indexOf(i) === -1)
    return newtag.join(' ');
}

//数値かどうかチェック（0-9のみ）
export function isNumber(value) {
    var regex = new RegExp(/^[0-9]+$/);
    return regex.test(value);
}

//任意小数桁で四捨五入
export function Round(value, digit) {
    //小数桁以内の場合そのまま返す
    if (getDecimalPointLength(value) <= digit) return value;
    let dgt = Math.pow(10, 5)
    value = Math.round(value * dgt) / dgt;  //浮動小数点誤差対応(小数第５位丸め)
    var digitVal = Math.pow(10, digit);
    return Math.round(value * digitVal) / digitVal;
}
//任意小数桁で切り上げ
export function Ceil(value, digit) {
    //小数桁以内の場合そのまま返す
    if (getDecimalPointLength(value) <= digit) return value;
    let dgt = Math.pow(10, 5)
    value = Math.round(value * dgt) / dgt;  //浮動小数点誤差対応(小数第５位丸め)
    var digitVal = Math.pow(10, digit);
    return Math.ceil(value * digitVal) / digitVal;
}
//任意小数桁で切り捨て
export function Floor(value, digit) {
    //4.1小数桁2とするとfloorで4.09が戻る為小数桁以内の場合そのまま返す
    if (getDecimalPointLength(value) <= digit) return value;
    let dgt = Math.pow(10, 5)
    value = Math.round(value * dgt) / dgt;  //浮動小数点誤差対応(小数第５位丸め)
    var digitVal = Math.pow(10, digit);
    return Math.floor(value * digitVal) / digitVal;
}
//小数桁数取得
export function getDecimalPointLength(number) {
    var numbers = String(number).split('.');
    return numbers[1] ? numbers[1].length : 0;
}
//整数桁数取得
export function getInteferPointLength(value) {
    const num = Math.trunc(Math.abs(value));
    return num === 0
        ? 1
        : Math.floor(Math.log10(num)) + 1;
}
//数値を指定した上桁数のみ取得 value=12345.12 degits=3の場合123
export function getFirstDigits(value, digits) {
    return Number(
        String(Math.trunc(Math.abs(value))).slice(0, digits)
    );
}
//金額丸め
export function GetRound(value, type) {
    if (type === 0 || type === "0") return Floor(value, 0);
    if (type === 1 || type === "1") return Round(value, 0);
    if (type === 2 || type === "2") return Ceil(value, 0);
    return value;
}
//桁指定丸め
export function GetDesitRound(value, type, digit) {
    if (type === 0 || type === "0") return Floor(value, digit);
    if (type === 1 || type === "1") return Round(value, digit);
    if (type === 2 || type === "2") return Ceil(value, digit);
    return value;
}
//負数の場合０を返す
export function PositiveValue(value) {
    let num = NumConv(value);
    return num<0?0:num;
}

//文字列が日付かどうか
export function isDate(str) {
    if (isEmpty(str)) {
        return false;
    }
    str = str.split('/').join('');
    //時間が存在する場合カット
    str = str.split(' ')[0];
    //null or 8文字でない or 数値でない場合はfalse
    if (str === null || str.length !== 8 || isNaN(str)) {
        return false;
    }

    //年,月,日を取得する
    var y = parseInt(str.substr(0, 4));
    var m = parseInt(str.substr(4, 2)) - 1;  //月は0～11で指定するため-1しています。
    var d = parseInt(str.substr(6, 2));
    var dt = new Date(y, m, d);

    //判定する
    return y === dt.getFullYear() && m === dt.getMonth() && d === dt.getDate();
}
//文字列をyyyy/mm/ddに成型する
export function FormatDate(str) {
    if (str.length === 10) return str;
    if (isEmpty(str)) return '';
    str = str.split('/').join('');
    //時間が存在する場合カット
    str = str.split(' ')[0];
    //null or 8文字でない or 数値でない場合はfalse
    if (str === null || str.length !== 8 || isNaN(str)) {
        return '';
    }
    var y = str.substr(0, 4);
    var m = str.substr(4, 2);
    var d = str.substr(6, 2);
    return y + "/" + m + "/" + d;
}
//日付値をyyyy/mm/ddに成型する
export function toStringDate(dt) {
    var y = dt.getFullYear();
    var m = ("00" + (dt.getMonth() + 1)).slice(-2);
    var d = ("00" + dt.getDate()).slice(-2);
    return y + "/" + m + "/" + d;
}
//日付値をyyyy/mmに成型する
export function toStringYM(dt) {
    var y = dt.getFullYear();
    var m = ("00" + (dt.getMonth() + 1)).slice(-2);
    return y + "/" + m;
}
//日付値をyyyyに成型する
export function toStringYYYY(dt) {
    var y = dt.getFullYear();
    return y;
}

//値がtrueか判定 true以外はfalse
export function isEnabled(value) {
    try {
        if (value === null) return false;
        if (value === undefined) return false;
        if (typeof value === "string") {
            return value.toLowerCase() === 'true';
        }
        if (value) return true;
        return false;
    } catch { return false;}
}
//値がfalseか判定 false以外はtrue
export function isFalse(value) {
    try {
        if (value === null) return true;
        if (value === undefined) return true;
        if (typeof value === "string") {
            return value.toLowerCase() === 'false';
        }
        if (!value) return false;
        return true;
    } catch { return true; }
}

//数値以外の場合0を返す
export function NumConv(value) {
    let newvalue = isNaN(value) ? 0 : value;
    return isEmpty(newvalue) ? 0 : Number(newvalue);
}

//string以外文字型に変換
export function StringConv(value) {
    if (isEmpty(value)) return "";
    if (typeof value === "string") {
        return value;
    }
    if (typeof value === "object") {
        return "";
    }
    return value.toString();
}

//ブランク以外の有効な値か判定 無効：true
export function isEmpty(value) {
    if (value === null) return true;
    if (value === undefined) return true;
    if (typeof value === "string") {
        return value.trim() === "";
    }
    return false;
}

//0か判定 ブランクや有効値でない場合0とみなす
export function isZero(value) {
    if (isEmpty(value)) return true;
    if (typeof value === "string") {
        return value.trim() === "0";
    }
    return value === 0;
}

//連想配列のキーに対する値を取得 キーが存在しない場合defvalue
export function DicVal(data, key, defvalue) {
    if (data === null) return defvalue;
    if (data === undefined) return defvalue;
    if (key in data) {
        if (defvalue === '') {
            return String(data[key]);       //文字列で返す
        } else {
            return data[key];
        }
    } else {
        return defvalue;
    }
}

//指定バイト数分文字を切り出す
export function ByteLeft(str, size, suffix) {
    if (!str) str = '';
    if (!size) size = 2;
    if (!suffix) suffix = '';
    var b = 0;
    for (var i = 0; i < str.length; i++) {
        b += str.charCodeAt(i) <= 255 ? 1 : 2;
        if (b > size) {
            return str.substr(0, i) + suffix;
        }
    }
    return str;
}
//文字列のバイト数を取得
export function ByteLength(str) {
    var r = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        // Shift_JIS: 0x0 ～ 0x80, 0xa0 , 0xa1 ～ 0xdf , 0xfd ～ 0xff
        // Unicode : 0x0 ～ 0x80, 0xf8f0, 0xff61 ～ 0xff9f, 0xf8f1 ～ 0xf8f3
        if ((c >= 0x0 && c < 0x81) || (c == 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
            r += 1;
        } else {
            r += 2;
        }
    }
    return r;
}
//文字の置換を行う
export function replaceall(str, src, to) {
    if (isEmpty(str)) return str;
    str = str.split(src);
    return str.join(to);
}

//文字列中のスペース（タブ）を削除
export function trim(str) {
    if (isEmpty(str)) return str;
    return str.replace(/\s+/g, "");
}

//文字列を半角に変換
export function toHalfWidth(strVal) {
    if (isEmpty(strVal)) return strVal;
    var halfVal = String(strVal).replace(/[！-～]/g,
        function (tmpStr) {
            // 文字コードをシフト
            return String.fromCharCode(tmpStr.charCodeAt(0) - 0xFEE0);
        }
    );
    return halfVal;
}

//計算結果を返す
export function Eval(formula) {
    if (isEmpty(formula)) return 0;
    try {
        return eval(formula);
    } catch (error) {
        console.log(error);
        return 0;
    }
}

//ゼロ詰め
export function PadZero(numVal, len) {
    if (numVal === '') {
        return '';
    }
    numVal = toHalfWidth(numVal).trim();
    // 数値でない
    if (!isNumber(numVal)) {
        return numVal;
    }
    if (numVal.length >= len) {
        return numVal;
    }
    return (Array(len).join('0') + numVal).slice(-len);
}

//記号で括った文字を返す
export function enclose(str, braces) {
    return braces.substr(1, 1) + str + braces.substr(2, 1);
}

//オブジェクトから重複データを除去
export function removeDuplicates(obj) {
    var result = [], comparisons = [], key, comparison;
    for (key in obj) {
        comparison = JSON.stringify(obj[key]);
        if (comparisons.indexOf(comparison) === -1) {
            result.push(obj[key]);
        }
        comparisons.push(comparison);
    }
    return result;
}
//arr1とarr2の差分を取得
export function arrayDiff(arr1, arr2) {
    var str_arr2 = JSON.stringify(arr2); //配列arr2の文字列表現
    return arr1.filter(item => str_arr2.indexOf(JSON.stringify(item)) < 0); //itemの文字列表現を検索。
}

//ウィンドウサイズ取得
export function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}

//ファイル名から拡張子を取得
export function GetExtension(filename) {
    let indexf = filename.lastIndexOf('.') + 1;
    if (indexf === 0) return "";
    let fileExtension = filename.substr(indexf);
    return fileExtension.toLowerCase();
}
//別タブへlogin状態の継続
export function continueSession(user, menus, menuinfo,state) {
    let key = RandomKey();
    key = "applm_keysession_" + key;
    Storestorage(key, {user:user, menus:menus, menuinfo:menuinfo, state:state} );
    return key;
}
//継続されたlogin情報の取得
export function getcontinuekey(key) {
    let data = Loadstorage(key);
    sessionStorage.removeItem(key);
    return data;
}
//ランダムキー生成
export function RandomKey(id) {
    if (isEmpty(id))
        return Math.random().toString(32).substring(2);
    else
        return id + "_" + Math.random().toString(32).substring(2);
}

export function applyDrag(arr, dragResult){
    const { removedIndex, addedIndex, payload } = dragResult;
    if (removedIndex === null && addedIndex === null) return arr;

    const result = [...arr];
    let itemToAdd = payload;

    if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0];
    }

    if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd);
    }

    return result;
};

//formid作成 id=「controller名:type#subkey」 ex)Code:season#xxx_240101000000
export function getformid(id, search) {
    if (search === "") return id;
    let query = new URLSearchParams(search);
    var type = query.get("type");
    var subkey = query.get("subkey");
    if (!isEmpty(type) && !isEmpty(subkey)) {
        return `${id}:${type}#${subkey}`;
    } else {
        if (!isEmpty(type)) {
            return `${id}:${type}`;
        }
        if (!isEmpty(subkey)) {
            return `${id}#${subkey}`;
        }
    }
}
export function getcontroller(id, search) {
    if (search === "") return id;
    let query = new URLSearchParams(search);
    var type = query.get("type");
    if (!isEmpty(type)) {
        return `${id}:${type}`;
    }
    return id;
}
export function getsubkey(search) {
    if (search === "") return "";
    let query = new URLSearchParams(search);
    var subkey = query.get("subkey");
    return !isEmpty(subkey) ? subkey : "";
}

export function stickynote(data) {
    let value = "";
    if (typeof data === 'object') {
        if ('note' in data) value = data.note;
    }
    return value;
}
export function stickymark(data) {
    let value = "";
    if (typeof data === 'object') {
        if ('mark' in data) value = data.mark;
    }
    return value;
}
export function stickycolor(data) {
    let value = "";
    if (typeof data === 'object') {
        if ('mark' in data) value = data.color;
    }
    return value;
}
export function numformat(number, colinfo) {
    if (isNaN(number)) return '';
    if (number === 0 && DicVal(colinfo,"format", "").indexOf('showzero') === -1) {
        return "-";
    }
    if (colinfo.length !== 0 && colinfo.length < getInteferPointLength(number)) {
        //入力桁数が指定桁をオーバーしている場合
        number = getFirstDigits(number, colinfo.length)
    }
    if (DicVal(colinfo,"format","").indexOf('unuseGrouping') !== -1) return number.toString(); //カンマ区切りなし
    if (DicVal(colinfo, "decimalplace",0) === 0) {
        return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    } else {
        return number.toLocaleString(undefined, {
            minimumFractionDigits: colinfo.decimalplace,
            maximumFractionDigits: colinfo.decimalplace
        });
    }
}
export function masterformat(value, data, coldef) {
    let colinfo = coldef.colinfo;
    if (!isEmpty(colinfo.dbcolumn)) {
        return value + ":" + data[coldef.colId + "_nm"];
    }
}
export function selectformat(value, colinfo) {
    let result = colinfo.options.find(e => e.code === value.toString());
    if (!isEmpty(result))
        return value + ":" + result.name;
    return value;
}

export function initializedata(colinfo, accctl) {
    if (isEmpty(colinfo)) return null;
    let data = {};
    let cols = colinfo.filter(e => e.initvalue !== "" && e.initvalue !== null)
    for (let i = 0; i < cols.length; i++) {
        let item = cols[i];
        switch (item.initvalue.toLowerCase()) {
            case "=today":
                let date = toStringDate(new Date());
                data[item.columnid] = date;
                break;
            case "=loginuser":
                if ("staff" in accctl) data[item.columnid] = accctl["staff"];
                break;
            default:
                if (item.initvalue.toLowerCase().indexOf('=accctl_') !== -1) {
                    var key = item.initvalue.toLowerCase().replace('=accctl_', '');
                    if (key in accctl) data[item.columnid] = accctl[key];
                } else {
                    data[item.columnid] = item.initvalue;
                }
                break;
        }
    }
    return cols.length===0?null:data;
}

export function Interval(waitmSec, callbackFunc,param ) {
    // 経過時間（秒）
    var spanedSec = 0;

    // 1秒間隔で無名関数を実行
    var id = setInterval(function () {

        spanedSec++;

        // 経過時間 >= 待機時間の場合、待機終了。
        if (spanedSec >= waitmSec) {

            // タイマー停止
            clearInterval(id);

            // 完了時、コールバック関数を実行
            if (callbackFunc) callbackFunc(param);
        }
    }, 100);
}
